import { Component, Input, OnInit } from '@angular/core';

import { FormControlService } from '../../services/form-control.service';
import { FormGroup } from '@angular/forms';
import { FormFieldDisplayType } from '@chatForm/src/app/models/form-field-display-type.enum';
import { DisplaySetting } from '../../models/display-setting';

@Component({
    selector: 'app-form-field',
    templateUrl: './form-field.component.html',
    styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() field;
    @Input() displaySetting: DisplaySetting;
    FieldDisplayType: typeof FormFieldDisplayType = FormFieldDisplayType;
    resources: any = resources;

    get formControl() { return this.form.controls[this.field.rowId]; }
    get isRequired() { return this.formControlService.isRequiredControl(this.formControl); }
    get invalid() { return this.formControl.invalid; }

    constructor(private formControlService: FormControlService) { }

    ngOnInit() { }

    getName(row: any): string {
        if (row.fieldTypeName === "Custom" || row.fieldTypeName === "Dropdown") {
            return `Parameters[ChatParam_${row.mappingFieldName}]`;
        }

        return row.mappingFieldName;
    }

    getFieldDisplayType(row: any): FormFieldDisplayType {
        if (row.options && row.options.length) return FormFieldDisplayType.Dropdown;
        if (row.mappingFieldName === 'Email') return FormFieldDisplayType.Email;
        return FormFieldDisplayType.PlainText;
    }

    getOptionLabel(option): string {
        return option.optionLanguages[0].optionLabel;
    }

    getOptionTooltip(option): string {
        const label: string = this.getOptionLabel(option);
        return label.length > 45 ? label : '';
    }

}
